import SideNav from 'src/side_nav/containers/SideNav'
export default SideNav
